/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorNextLicenseEndpointResponse
 */
export interface StorNextLicenseEndpointResponse {
    /**
     * 
     * @type {string}
     * @memberof StorNextLicenseEndpointResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof StorNextLicenseEndpointResponse
     */
    expiry: string;
    /**
     * 
     * @type {string}
     * @memberof StorNextLicenseEndpointResponse
     */
    capacity: string;
}

export function StorNextLicenseEndpointResponseFromJSON(json: any): StorNextLicenseEndpointResponse {
    return StorNextLicenseEndpointResponseFromJSONTyped(json, false);
}

export function StorNextLicenseEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorNextLicenseEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'expiry': json['expiry'],
        'capacity': json['capacity'],
    };
}

export function StorNextLicenseEndpointResponseToJSON(value?: StorNextLicenseEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'expiry': value.expiry,
        'capacity': value.capacity,
    };
}


